import { COMMON_STATE } from '@/api/resources/entityState/common-state'
import { EntityState } from '@/api/resources/entityState/entity-state'
import { commonStatusService } from '@/api/services/common/status/common-status.service'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { keyBy, merge } from 'lodash'
import { store } from '@/store/store'

export const SUBPORTION_STATES = {
    DRAFT: { code: 'DRAFT', class: 'state-draft', order: 10 },
    REGISTERED: { code: 'REGISTERED', class: 'state-primary', order: 20 },
    CUT: { code: 'CUT', class: 'state-process-1', order: 30 },
    IN_STAINER: { code: 'IN_STAINER', class: 'state-process-2', order: 40 },
    STAINED: { code: 'STAINED', class: 'state-process-3', order: 50 },
    IN_COVERING: { code: 'IN_COVERING', class: 'state-process-4', order: 60 },
    COVERED: { code: 'COVERED', class: 'state-process-5', order: 70 },
    IN_SCANNER: { code: 'IN_SCANNER', class: 'state-process-6', order: 80 },
    SCANNED: { code: 'SCANNED', class: 'state-success', order: 90 },
    SENT_TO_PATHOLOGIST: { code: 'SENT_TO_PATHOLOGIST', class: 'state-success', order: 100 },
    ARCHIVED: { code: COMMON_STATE.ARCHIVED, class: 'state-archived', order: 110 },
    DISCARDED: { code: 'DISCARDED', class: 'state-discarded', order: 120 },
    CANCELED: { code: 'CANCELED', class: 'state-canceled', order: 130 },
    IN_SHIPMENT: { code: 'IN_SHIPMENT', class: 'state-shipment', order: 140 },
    OUT_OF_LABORATORY: { code: 'OUT_OF_LABORATORY', class: 'state-out-of-laboratory', order: 150 }
}

class SubportionState extends EntityState {
    protected get entityName(): string {
        return 'subportion'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const states = await commonStatusService.getSubportionStates()
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(SUBPORTION_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }
}

export const subportionState = new SubportionState()
